import React from 'react';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { MenuItem } from 'react-bootstrap';

import { Range } from 'rc-slider';

const TimeSelectProps = {
    startTime: PropTypes.number.isRequired,
    endTime: PropTypes.number.isRequired,
    startTimeLabel: PropTypes.string.isRequired,
    endTimeLabel: PropTypes.string.isRequired,
    updateTime: PropTypes.func.isRequired,
    selectTime: PropTypes.func.isRequired,
    clearTime: PropTypes.func.isRequired
};

const TimeSelect = (props) => {
    const {
        startTime,
        endTime,
        startTimeLabel,
        endTimeLabel,
        updateTime,
        selectTime,
        clearTime,
        color
    } = props;

    const rangeAttrs = {
        allowCross: false,
        min: 0,
        max: 24,
        defaultValue: [startTime, endTime],
        value: [startTime, endTime],
        onChange: value => updateTime(value),
        onAfterChange: value => selectTime(value)
    };
    if (color) {
        rangeAttrs.handleStyle = [
            {backgroundColor: `${color}`, color: `${color}`, border: `solid 2px ${color}`},
            {backgroundColor: `${color}`, color: `${color}`, border: `solid 2px ${color}`}
        ];
        rangeAttrs.trackStyle = [{backgroundColor: `${color}`, color: `${color}`}];
    }

    return (
        <Fragment>
            <div className="times-wrapper">
                <div className="start-time">
                    <span>Start</span>
                </div>
                <div className="end-time">
                    <span>End</span>
                </div>
            </div>
            <div className="select-wrapper">
                <Range {...rangeAttrs} />
            </div>
            <div className="times-wrapper">
                <div className="start-time">
                    <time>{startTimeLabel}</time>
                </div>
                <div className="end-time">
                    <time>{endTimeLabel}</time>
                </div>
            </div>
            <div className="reset-time-wrapper">
                <div className="clear-tags custom-color color-1" onClick={() => clearTime()}>Reset</div>
            </div>
        </Fragment>
    );
};

TimeSelect.propTypes = TimeSelectProps;

const TimeSelectContainer = props => {
    const timeSelect = TimeSelect(props);
    return (
        <Fragment>
            <div className="hidden-xs time-select-wrapper">
                {timeSelect}
            </div>
            <div className="visible-xs time-select-wrapper-mobile">
                {timeSelect}
            </div>
        </Fragment>
    );
};

const TimeFilterProps = {
    id: PropTypes.string.number,
    selectedCategoryId: PropTypes.string.number,
    type: PropTypes.string.isRequired,
    startTime: PropTypes.number.isRequired,
    endTime: PropTypes.number.isRequired,
    startTimeLabel: PropTypes.string.isRequired,
    endTimeLabel: PropTypes.string.isRequired,
    selectFilterCategory: PropTypes.func.isRequired,
    updateTime: PropTypes.func.isRequired,
    clearTime: PropTypes.func.isRequired
};

const TimeFilter = (props) => {
    const {
        id,
        startTime,
        startTimeLabel,
        endTime,
        endTimeLabel,
        updateTime,
        selectTime,
        clearTime,
        selectFilterCategory,
        selectedCategoryId,
        color
    } = props;

    const timeSelectProps = {
        startTime,
        startTimeLabel,
        endTime,
        endTimeLabel,
        updateTime,
        selectTime,
        clearTime,
        color
    };

    const isSelected = selectedCategoryId === id;
    const clsMenuItem = classnames({'custom-color color-1': isSelected});
    const clsCategory = classnames('category', {'selected': isSelected});

    const menuItemProps = {
        eventKey: id,
        onSelect: selectFilterCategory,
        active: isSelected,
        className: clsMenuItem
    };

    return (
        <div className={clsCategory}>
            <MenuItem {...menuItemProps}>
                <span style={isSelected ? {color} : {}}>Time</span><i className="fa icon-AgendaAtt_arrow custom-color color-1"/>
            </MenuItem>
            {isSelected && <TimeSelectContainer {...timeSelectProps} /> }
        </div>
    );
};

TimeFilter.propTypes = TimeFilterProps;

export default TimeFilter;
